import confetti from 'canvas-confetti';

export function fireConfettiBurst() {
  const defaults = { startVelocity: 35, spread: 360, ticks: 60, zIndex: 1000, colors: ['#0055FF', '#FFD600', '#00D95F', '#9D4CDD', '#FF5A00'] };
  const end = Date.now() + 900;
  (function frame() {
    confetti({ ...defaults, particleCount: 50, origin: { x: Math.random() * 0.3 + 0.1, y: Math.random() * 0.3 } });
    confetti({ ...defaults, particleCount: 50, origin: { x: Math.random() * 0.3 + 0.6, y: Math.random() * 0.3 } });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export function fireCenterPop() {
  confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 }, colors: ['#0055FF', '#FFD600', '#00D95F', '#FF5A00', '#9D4CDD'] });
}
